import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50 flex flex-col items-center justify-center text-center px-4">
      <p className="font-heading font-extrabold text-8xl md:text-9xl text-background-200 select-none">
        404
      </p>
      <h1 className="font-heading font-semibold text-xl md:text-2xl text-foreground-950 mt-6">
        Page not found
      </h1>
      <p className="mt-2 text-sm text-foreground-500 font-mono">{location.pathname}</p>
      <Link
        to="/"
        className="mt-8 inline-flex items-center gap-2 rounded-md bg-primary-500 text-background-50 px-6 py-3 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
      >
        <span className="w-5 h-5 flex items-center justify-center">
          <i className="ri-home-4-line text-base" />
        </span>
        Back to Home
      </Link>
    </div>
  );
}